import { ValidatorService } from './../../../services/tools/validator.service';
import { Message1ModalComponent } from './../../tools/modals/message1-modal/message1-modal.component';
import { AutenticacionService } from './../../../services/autenticacion.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild(Message1ModalComponent) message1Modal: Message1ModalComponent;
  public username: string;
  public password: string;
  public processing: boolean;

  constructor(private authService: AutenticacionService, private router: Router, private validatorService: ValidatorService) {
    this.processing = false;
  }

  ngOnInit() {
  }

  canLogin() {
    return (this.validatorService.required(this.username) && this.validatorService.required(this.password));
  }

  login() {

    if(!this.canLogin()) {
      return false;
    }

    this.processing = true;
    this.authService.login(this.username, this.password).subscribe(
      (response) => {
        const respuesta = response.json();
        if (respuesta.success) {
          this.processing = false;
          this.authService.setUser(respuesta.content);
          console.log("User: ", respuesta.content);
          //Revisamos si es de tipo gestor de gastos para que muestre la vista correspondiente
          if(respuesta.content.user.idUsuarios_Permisos === 4 ){
            this.router.navigate(['/gastos']);
          }else if(respuesta.content.user.idUsuarios_Permisos === 5){
            this.router.navigate(['/fondeadores/perfil-fondeador/'+respuesta.content.user.idFondeador]);
            localStorage.setItem("User_fondeador", JSON.stringify({isFondeador: true}));
          }else if(respuesta.content.user.idUsuarios_Permisos === 6){
            this.router.navigate(['/modulo-vista']);
            localStorage.setItem("Ejecutivo_fondeador", JSON.stringify({isEjecutivoFondeador: true}));
          }else if(respuesta.content.user.idUsuarios_Permisos === 7){
            this.router.navigate(['/reportes']);
          }else{
            this.router.navigate(['/']);
          }
        }
      }, (error) => {
        this.processing = false;
        const content_error = error.json().content;
        let message = 'No se completó la acción. Por favor, intentelo más tarde.';
        if (error.status == 400 && (content_error.error == 'invalid_credentials' || content_error.username)) {
          message = 'El usuario y la contraseña ingresada no coinciden con nuestra base de datos, inténtelo nuevamente.';
        } else if (error.status == 400) {
          message = content_error.message;
        }
        this.message1Modal.open({
          'title': 'Información inválida',
          'message': message
        });
      }
    );
  } 


}



// WEBPACK FOOTER //
// ./src/app/components/autenticacion/login/login.component.ts